export default "__VITE_ASSET__C5e7az3f__"